var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "events-page container homebase-container pt-5 pb-5" },
    [
      _c("div", [_c("back-to-home-button")], 1),
      _vm._v(" "),
      _c("event-feed", {
        attrs: {
          title: "Autodesk Event Calendar",
          events: _vm.events,
          topics: _vm.topics,
          calendarEvents: _vm.calendarEvents,
          "is-loading": _vm.isLoading,
          "is-errored": _vm.isErrored,
          "show-load-more": _vm.showLoadMore,
          "is-more-loading": _vm.isMoreLoading
        },
        on: {
          onLoadMore: _vm.handleLoadMoreClicked,
          interestsSaved: _vm.resetEventsFeed
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1dbe5c9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dbe5c9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/pages/EventsPage.vue
// module id = null
// module chunks = 